const generatePageHref = (
  queryOriginal,
  targetPage,
  getLink,
  isReferencePage,
  isAdvancedSearch
) => {
  const { category, subCategory, vehicle, page, ...query } = queryOriginal;

  return getLink(isAdvancedSearch
    ? 'advanced-search-products-search'
    : 'search',
    {
      ...query,
      ...(category ? { category: category } : {}),
      ...(subCategory ? { subCategory: subCategory } : {}),
      ...(vehicle ? { vehicle: vehicle } : {}),
      ...(targetPage > 1 ? { page: targetPage } : {}),
    }
  );
};

export default generatePageHref;
